module.exports = __webpack_public_path__ + "static/game-campanies-7a52ab6c72ec11134c517f0d8cc47f84.jpg";